"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FollowingIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M20.99 6a.98.98 0 0 1-.29.7l-1.33 1.27 1.28 1.3a.98.98 0 0 1-.41 1.7.99.99 0 0 1-.98-.32l-1.98-1.97a.98.98 0 0 1 0-1.39l2.04-2.03a.99.99 0 0 1 1.08-.19c.37.16.6.52.59.92M5 14c0-1.1.9-2 2.01-2h7.98c1.11 0 2.01.89 2.01 2.01v4.44c0 3.41-12 3.41-12 0z"/><circle cx="11" cy="7" r="4"/></g></svg>`
}, props));
FollowingIcon.displayName = 'FollowingIcon';
var _default = exports.default = FollowingIcon;